import { clientId, lpRequest } from '../../../../core/api/lp-request';

export const uploadDriverImage = async (driver_id: string, file: any): Promise<any> => {
  const body = new FormData();
  body.append('image', file);

  return lpRequest(`/client/${clientId()}/drivers/${driver_id}/image`, { method: 'POST', body });
};
